










































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import Button from './Button.vue';
import $ from 'jquery';
import { dateComparision, formatDate, getDateAsMoment, itemsPerPageOptionsTable } from '../../core/utils';
import { dateTypes } from '../models';
@Component({
    components: {
        Button
    }
})
export default class TableGeojson extends Vue {
    @Prop({ default: false }) loading: boolean;
    @Prop({ default: true }) selectable: boolean;
    @Prop({ default: false }) excludeItem: boolean;
    @Prop({ default: true }) hideId: boolean;
    @Prop({ default: 'No data' }) noDataText: string;
    @Prop({ default: '' }) hideColumn: string;
    @Prop({ default: '' }) search: string;
    @Prop({ default: [] }) items: Array<object>;
    @Prop({ default: [] }) headers: Array<object>;
    itemsPerPageOptions: Array<number> = itemsPerPageOptionsTable;
    selectAll: boolean = false;

    selectedItems: any = [];

    @Watch('selectedItems')
    observableSelectedItems(items) {
        this.$emit('selected-items', items);
    }

    @Watch('loading')
    observableLoading(value) {
        if (value) {
            this.selectedItems = [];
            this.$emit('selected-items', []);
        }
    }

    get getHeaders() {
        return this.headers.filter(function(item) {
            if (item['text'] === 'source') {
                item['text'] = 'Fuente';
            } else if (item['text'] === 'name') {
                item['text'] = 'Nombre';
            }
            return item['value'] !== 'id';
        });
    }

    renderColumn(prop) {
        if (prop !== 'customId') {
            if (this.hideId && prop === 'id') {
                return false;
            }
            return true;
        } else {
            return false;
        }
    }

    toggleSelectAll() {
        this.selectAll = !this.selectAll;
        if (this.selectAll) {
            this.selectedItems = this.items;
        } else {
            this.selectedItems = [];
        }
    }

    @Emit()
    excludeAction(item) {}

    customSort(items: any[], sortBy: string[], sortDesc: boolean[]) {
        items.sort(function(a, b) {
            let sorts: number[] = [];

            for (let i = 0; i < sortBy.length; i++) {
                let condition = 0;
                switch (sortBy[i]) {
                    case 'properties.start_date':
                    let valueAStartDate: null | Date = null;
                    let valueBStartDate: null | Date  = null;

                    if (a['properties']['start_date'] && b['properties']['start_date']) {
                        valueAStartDate = getDateAsMoment(a['properties']['start_date'], dateTypes.dateFilesFormat).toDate();
                        valueBStartDate = getDateAsMoment(b['properties']['start_date'], dateTypes.dateFilesFormat).toDate();
                    } else if (a['properties']['start_date']) {
                        return sortDesc[i] ? -1 : 1; // a has a start_date, but b does not
                    } else if (b['properties']['start_date']) {
                        return sortDesc[i] ? 1 : -1; // b has a start_date, but a does not
                    } else {
                        return 0;
                    }
                    condition = dateComparision(valueAStartDate, valueBStartDate, sortDesc[i]);
                    break;

                    case 'properties.end_date':
                    let valueAEndDate: null | Date = null;
                    let valueBEndDate: null | Date  = null;

                    if (a['properties']['end_date'] && b['properties']['end_date']) {
                        valueAEndDate = getDateAsMoment(a['properties']['end_date'], dateTypes.dateFilesFormat).toDate();
                        valueBEndDate = getDateAsMoment(b['properties']['end_date'], dateTypes.dateFilesFormat).toDate();
                    } else if (a['properties']['end_date']) {
                        return sortDesc[i] ? -1 : 1; // a has a end_date, but b does not
                    } else if (b['properties']['end_date']) {
                        return sortDesc[i] ? 1 : -1; // b has a end_date, but a does not
                    } else {
                        return 0;
                    }
                    condition = dateComparision(valueAEndDate, valueBEndDate, sortDesc[i]);
                    break;

                    default:
                        let valueA = a['properties'][sortBy[i]] || '';
                        let valueB = b['properties'][sortBy[i]] || '';

                        if (typeof valueA === 'string' && typeof valueB === 'string') {
                            if (!sortDesc[i]) {
                                condition = valueA.localeCompare(valueB);
                            } else {
                                condition = valueB.localeCompare(valueA);
                            }
                        }

                        if(typeof valueA === 'number' && typeof valueB === 'number'){
                            if (!sortDesc[i]) {
                                condition = valueA - valueB;
                            } else {
                                condition = valueB - valueA;
                            }
                        }
                        
                        break;
                }
                sorts.push(condition);
            }
            let result = 0;
            for (let i = 0; i < sorts.length; i++) {
                if (sorts[i] != 0) {
                    return sorts[i];
                }
            }
            return result;
        });
        return items;
    }

    customFilter(items, search, filter) {
        if (search !== '') {
            search = search.toLowerCase();
            let nameToFilter = filter['properties']['name'].toLowerCase();
            return nameToFilter.includes(search);
        }
        // if (filter.driver.name !== null) {
        //     return (
        //         filter.driver.name.toLowerCase().includes(search.toString().toLowerCase()) ||
        //         filter.driver.id.toString().includes(search) ||
        //         filter.vehicle.vehicle_plate.includes(search.toString().toUpperCase())
        //     );
        // } else {
        //     return (
        //         filter.driver.id.toString().includes(search) ||
        //         filter.vehicle.vehicle_plate.includes(search.toString().toUpperCase())
        //     );
        // }
    }
}
